__turbopack_context__.v({
  "root": "NHRVOW_root",
});
